import React from 'react';
import './category-tags.scss';
import { hash } from '@zonofi/common/functions/hash';
import { ExpandableMenu, ExpandableMenuItem, TagChip } from '../../components';
import { ProductVariantCategory } from '@zonofi/zono-money-store';

interface CategoryTagsProps {
  categories: ProductVariantCategory[];
  visibleCount?: number; // How many categories to show initially
}

export const CategoryTags: React.FC<CategoryTagsProps> = ({ categories }) => {
  if (!categories?.length) return null;

  const visibleCategories = categories[0];
  const additionalCategories = categories.slice(1);
  const colorIndex = hash(visibleCategories.categoryName, 5);

  const mainContent = (
    <div className="visible-categories">
      <TagChip
        key={visibleCategories.categoryId}
        tagName={visibleCategories.categoryName}
        needTagIcon={false}
        variant={colorIndex + 1}
      />
    </div>
  );

  const additionalItems: ExpandableMenuItem[] = additionalCategories.map(
    (category) => {
      const colorIndex = hash(category.categoryName, 5);
      return {
        id: category.categoryId.toString(),
        content: (
          <TagChip
            tagName={category.categoryName}
            needTagIcon={false}
            variant={colorIndex + 1}
          />
        ),
      };
    }
  );

  return (
    <div className="product-category-view">
      <ExpandableMenu
        mainContent={mainContent}
        additionalItems={additionalItems}
        triggerComponent={(count, onToggle) => (
          <div onClick={onToggle}>
            <TagChip tagName={`+${count}`} needTagIcon={false} variant="gray" />
          </div>
        )}
        className="category-tags-expandable"
        popupClassName="category-tags-popup"
        popupItemClassName="category-popup-item"
      />
    </div>
  );
};
